/** 
    This palette is sourced from our Paper Design System:
    https://www.figma.com/file/5STfS2S1ZENSmBAfeTZry2/Paper-Design-System?node-id=110-1654&t=ICM935S9ExDRRYlu-0

    This palette requires some revision to better systematize it for use
    within our component library.

    It is therefore subject to change so please use it with discretion.
*/
export const palette = {
  black: '#000000',
  white: '#FFFFFF',
  brand: {
    100: '#FF6552', // NEW BRAND COLOR (LUCKY BREAK)
    90: '#F46764',
    80: '#F67B79',
    70: '#F89C9A',
    60: '#FBBDBC',
    50: '#FDDEDD',
    40: '#FEEEEE',
  },
  neutral: {
    90: '#1D2332',
    80: '#373D4C',
    70: '#4F5564',
    60: '#676E7E',
    50: '#838998',
    40: '#A2A6B2',
    30: '#BFC2CB',
    20: '#DBDDE4',
    10: '#EBEDF2',
    5: '#F0F1F5',
    3: '#F7F8FA',
  },
  red: {
    100: '#E01E29',
    70: '#E96169',
    40: '#F3A5A9',
    10: '#F9D2D4',
  },
  yellow: {
    100: '#E49011',
    70: '#ECB158',
    40: '#F4D3A0',
    10: '#FAE9CF',
  },
  blue: {
    100: '#3755F3',
    70: '#7388F7',
    40: '#AFBBFA',
    10: '#D7DDFD',
  },
  green: {
    100: '#18B171',
    70: '#5DC89C',
    40: '#A3E0C6',
    10: '#D1EFE3',
  },
} as const;

export { paletteRebrand } from './palette-rebrand';
